<template style="height: 100%;">
  <el-container style="height: 100%; border: 1px solid #eee">
    <el-aside v-show="!isCollapse">
      <div style="padding: 8px 0px;text-align:center;background: #000;max-width: 100%;">
        <div class="block">
          <el-avatar shape="square" src="/static/images/logo.png"></el-avatar>
          <span class="apptitle">智慧校园服务平台</span>
        </div>
      </div>
      <div style="width:100%">
        <el-menu
          :default-openeds="defaultOpeneds"
          :router="true"
          :unique-opened="true"
          background-color="#545c64"
          text-color="#dadada"
          active-text-color="#ffd04b"
          acitve-background-color="#3a3d40"
        >
          <el-submenu :key="menu.id" :index="menu.id" v-for="menu in menuData">
            <template slot="title">
              <i class="el-icon-menu"></i>
              {{menu.text}}
            </template>
            <el-menu-item
              :key="submenu.id"
              :index="submenu.id"
              :route="{path:submenu.target}"
              v-for="submenu in menu.children"
            >{{submenu.text}}</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </el-aside>

    <el-container style="margin-left:200px;">
      <el-header style="text-align: right; font-size: 12px;">
        <ul class="nav">
          <li class="nav-item nav-theme-switch">
            <!-- <span style="float:left" @click="isCollapse=!isCollapse">
              <span class="subnavsymbol">
                <i class="el-icon-s-fold"></i>
              </span>
            </span> -->
            <!-- <span style="float:left">
              <span class="subnavsymbol">|</span>
            </span>
            <span style="float:left">
              <span class="subnavtitle">版本号：V2.7（更新日期： 2020.3.30 03）</span>
            </span> -->
            <span style="position: relative;top: 10px;margin-right: 10px;">
              <img class="photo1" src="/static/images/head.jpeg" />
            </span>
            <span class="user">
              <el-dropdown trigger="click" @command="userDropdownCommand">
                <span class="el-dropdown-link">
                  {{UserData.name}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="modifypassword">修改密码</el-dropdown-item>
                  <el-dropdown-item command="return">返回平台</el-dropdown-item>
                  <el-dropdown-item command="logout">退出系统</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
            <span class="navt-menu" @click="linkIndex">首页</span>
          </li>
        </ul>
      </el-header>

      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
    <el-dialog title="修改密码" :visible.sync="dialogChangePassword" modal width="500px">
      <ChangePassword @onChangePasswordOk="onChangePasswordOk"></ChangePassword>
    </el-dialog>
  </el-container>
</template>
<script>
import { GetAdminPermissionAdminMenu } from "../../../api/privilege/permission";
import util from "../../../common/util";
import config from "../../../common/config";
import { UserManager } from "oidc-client";
import ChangePassword from "./change_password";
export default {
  name: "Home",
  components: { ChangePassword },
  data() {
    return {
      // tableData: Array(20).fill(item),
      dialogChangePassword: false,
      menuData: [
        {
          id: "1",
          text: "系统管理",
          children: [
            {
              id: "1-1",
              text: "菜单管理",
              target: "/admin/privilege/adminmenu"
            },
            {
              id: "1-2",
              text: "角色管理",
              target: "/admin/privilege/adminrole"
            },
            {
              id: "1-3",
              text: "用户管理",
              target: "/admin/privilege/application_user"
            }
          ]
        }
      ],
      defaultOpeneds: [],
      UserData: {
        name: "admin",
        FullName: ""
      },
      MyNewNoticeCount: 0,
      isCollapse: false
    };
  },
  methods: {
    userDropdownCommand: function(command) {
      var mgr = new UserManager(config);
      switch (command) {
        case "logout":
          sessionStorage.clear();
          mgr.signoutRedirect();
          this.$router.push({ name: "Home" });

          break;
        case "modifypassword":
          this.dialogChangePassword = true;
          // this.$router.push({ name: "ModifyPassword" });
          break;
        case "profile":
          this.$router.push({ name: "UserProfile" });
          break;
        case "register":
          this.$router.push({ name: "SchoolProfile" });
          break;
        case "suggest":
          this.$router.push({ path: "/app/suggest" });
          break;
        case "return":
          sessionStorage.clear();
          window.location.href = config.authority;
          break;
      }
    },
    onChangePasswordOk: function() {
      this.dialogChangePassword = false;
    },
    linkIndex: function() {
      this.$router.push({ name: "Welcome" });
    },
    getAdminPermission: function() {
      var that = this;
      GetAdminPermissionAdminMenu().then(function(result) {
        if (result.success) {
          that.menuData = result.data || [];
          if (that.menuData.length > 0) {
            that.defaultOpeneds = [
              that.menuData[0].target,
              that.menuData[0].children[0].target
            ];
          }
        }
      });
    },
    initUser: function() {
      let that = this;
      that.UserData = util.getUser();
    },
    initNewNoticeCount: function() {
      let that = this;
      getMyNewNoticeCount().then(function(result) {
        if (result.success) {
          that.MyNewNoticeCount = result.data || 0;
        }
      });
    }
  },
  created: function() {
    // this.initNewNoticeCount();
  },
  mounted: function() {
    let that = this;

    this.getAdminPermission();
    this.initUser();
    if (!window.worker && typeof Worker !== "undefined") {
      // window.worker=new Worker('/refreshtoken.js');
      //window.worker.onmessage=function (event) {
      //refreshToken(that);
      //}
    }
  }
};
</script>
<style lang="scss" scoped>
.el-avatar {
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  color: #fff;
  background: #c0c4cc00;
  width: 30px;
  height: 30px;
  line-height: 40px;
  font-size: 14px;
}
.apptitle {
  color: rgb(255, 255, 255);
  text-align: center;
  font-size: 16px;
  margin-left: 5px;
  position: relative;
  top: -8px;
}
.el-header {
  padding: 0 10px 20px 20px;
  background-color: #e8f0fb;
  color: #333;
  height: 50px !important;
  line-height: 50px;
  // border-bottom: 1px solid #d4d4d4;
  display: block;
  top: 0px;
  bottom: 0px;
  // position: absolute;
}
.navt-menu {
  cursor: pointer;
  margin-right: 1px;
  float: right;
  // background: #caddf7;
  padding: 0 5px;
}
.user {
  float: right;
  // background: #caddf7;
  padding: 0 5px;
}
.el-main {
  top: 0px;
  bottom: 0px;
  position: relative;
  width: 100%;
  background: #fff;
}
.el-aside {
  color: #333;
  display: block;
  overflow-y: auto;
  width: 200px !important;
  top: 0px;
  bottom: 0px;
  left: 0px;
  position: fixed;
  background-color: #545c64;
}
.photo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin: 15px;
}
.photo2 {
  width: 20%;
}

.photo1 {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  // margin: 10px 15px;
  // position: absolute;
  // right: 80px;
  border: 1px solid #c3c3c3;
}
.el-menu {
  border-right: solid 0px #e6e6e6;
  list-style: none;
  position: relative;
  margin: 0;
  padding-left: 0;
  background-color: #fff;
  height: 100%;
}
.el-menu-item,
.el-submenu__title {
  height: 45px;
  line-height: 45px;
  position: relative;
  -webkit-box-sizing: border-box;
  white-space: nowrap;
  list-style: none;
}

.el-main {
  padding: 0;
}
.logotitle {
  font-size: 18px;
  cursor: pointer;
}
.el-dropdown-link {
  cursor: pointer;
  color: #000;
}
.logo {
  width: 80px;
  height: 40px;
  float: left;
  position: relative;
  top: 15px;
}
.headertitle {
  line-height: 72px;
  font-size: 22px;
  color: #ffffff;
}
.subnavsymbol {
  margin-right: 5px;
  color: #409eff;
  font-weight: 900;
  font-size: 22px;
}
.subnavtitle {
  font-size: 14px;
  color: #7d7d7d;
  font-weight: 300;
}
.el-dialog__header {
  padding: 20px 20px 10px;
  background: #020202 !important;
}
.el-dialog__body {
  padding: 0px !important;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/public/Layout.vue